import React, {useState, useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import {
  HubspotFormMain,
  FormHaeding,
  HubspotFormWrapper,
  InfoText,
  ItemSectionTitle
} from './index.style'
import Container from '@components/Container'
import RichText from '@components/RichText'
import CMSButton from '@components/CMSButton'
import { colors } from '@styles/vars/colors.style'
import Spacer from '@components/Spacer'
import Grid from '@components/Grid'
import { useForm } from 'react-hubspot'
import GridItem from '@components/GridItem'
import Input from '@components/Input'
import Textarea from '@components/Textarea'
import Select from '@components/Select'
import Button from '@components/Button'
import IconArrowRight from '@svgs/IconArrowRight'
import Checkbox from '@components/Checkbox'
import Radio from '@components/Radio'

const HubspotForm = ({
  content
}) => {
  
  const { text, backgroundColour, textColour, formId, submitText, successMessage,formBottomInfo , privacyPolicyCheckText, additionalFields } = content
  const background = backgroundColour
    ? backgroundColour
    : colors.charcoal;
  const color = textColour ? textColour : colors.white
  const [submitted, setSubmitted] = useState(false)
  const [canSend, setCanSend] = useState(false);
  const [slideOpened, setSlideOpened] = useState(true);
  

	const formRef = useRef();
	const emailInput = useRef();

	useEffect(() => {
    if (submitted) formRef.current.reset()
  }, [submitted])

	const { data, isLoading, isError, handleSubmit } = useForm({
	    portalId: '25832621',
	    formId
	})

	useEffect(()=>{
	    if(data?.data.inlineMessage) {
	    	setSubmitted(true)
	    }
	},[data]);

  const requiredItems = additionalFields.filter(item => item.isRequired).reduce((acc, item) => {
    acc[item.name] = "";
    return acc;
  }, {});

  const requiredItemsTypes = additionalFields.filter(item => item.isRequired).reduce((acc, item) => {
    acc[item.name] = item.type;
    return acc;
  }, {});

  const initialFormData = requiredItems ? requiredItems : {};

  const [formData, setFormData] = useState(initialFormData);

  const validateForm = () => {
    let isValid = true;

    // Validate first name
    Object.keys(requiredItemsTypes).map((key) => {
      if (requiredItemsTypes[key] === 'Text' || requiredItemsTypes[key] === 'Textarea') {
        if (formData[key].trim() === '') {
          isValid = false;
        }
      }
      if (requiredItemsTypes[key] === 'Email') {
        if (formData[key].trim() === '') {
          isValid = false;
        } else if (!isValidEmail(formData[key])) {
          isValid = false;
        }
      }
      if (requiredItemsTypes[key] === 'Phone') {
        if (formData[key].trim() === '') {
          const phoneLength = formData[key].trim().length;
          const minLength = 10;
          const maxLength = 16;

          if (phoneLength < minLength || phoneLength > maxLength) {
            isValid = false;
          }

          return isValid;
        }
      }
      if (requiredItemsTypes[key] === 'Radio') {
        if (!formData[key]) {
          isValid = false;
        }
      }
    })
    
    return isValid;
  };

  const isValidEmail = (email) => {
    // Basic email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name] :  value
    }));
  };

  const handleTelhange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name] :  value.replace(/\D/g, '')
    }));
  }

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name] :  value
    }));
  }
  
  useEffect(() => {
    if (validateForm()) {
      setCanSend(true);
    } else {
      setCanSend(false);
    }
  }, [formData])

  const sendAnother = () => {
    setSlideOpened(!slideOpened)
  }

  return (
    <HubspotFormMain id="hubspot-form">
        <HubspotFormWrapper>
          <FormHaeding>
            {text && <RichText content={text} />}
          </FormHaeding>
          <Spacer size={[20, 60]} />
              <form onSubmit={handleSubmit} ref={formRef} >
                <Grid>
                {additionalFields && additionalFields.map((item, index) => (
                    <GridItem tabletL={item.isTwoColumns ? 7 : 14}>
                    <Spacer size={40}/>
                    {item.sectionTitle && <ItemSectionTitle>{item.sectionTitle}</ItemSectionTitle>}
                    <Spacer size={10}/>
                    {(item.type === 'Text' || item.type === 'Email' || item.type === 'Phone') &&
                      <>
                      {item.isRequired ?
                        <Input
                          id={item.name}
                          name={item.name}
                          label={item.title}
                          value={item.isRequired ? formData[item.name] : ''}
                          onChange={item.isRequired ? handleChange : null}
                          type={(item.type === 'Text') ? 'text' : item.type === 'email' ? 'email' : 'tel'}
                        />
                      :
                        <Input
                          id={item.name}
                          name={item.name}
                          label={item.title}
                          type={(item.type === 'Text') ? 'text' : item.type === 'email' ? 'email' : 'tel'}
                        />
                      } 
                      </>
                    }
                    {(item.type === 'Textarea') &&
                      <>
                      {item.isRequired ?
                        <Textarea
                            id={item.name}
                            name={item.name}
                            label={item.title}
                            value={formData[item.name]}
                            onChange={handleChange}
                            rows="3"
                        />
                        :
                        <Textarea
                            id={item.name}
                            name={item.name}
                            label={item.title}
                            rows="3"
                        />
                      }
                      </>
                    }
                    {(item.type === 'Radio') &&
                      <Radio
                          id={item.name}
                          name={item.name}
                          checked={item.name}
                          values={item.values}
                          title={item.title}
                          subTitle={item.subTitle}
                          onChange={item.isRequired ? handleSelectChange : null}
                          value={item.isRequired ? formData[item.name] : ''}
                      >
                      </Radio>
                    }
                    </GridItem>
                ))}
                </Grid>
                <Spacer size={40}/>
                {!submitted && (
                    <Button
                      variant="text"
                      disabled={!canSend}
                      iconRight={<IconArrowRight />}
                      onClick={() => {}}
                      color="currentColor"
                      type="submit"
                    >
                      {submitText ? submitText : 'Send message'}
                    </Button>
                )}

                {submitted && 
                    <p>{successMessage}</p>
                }
              </form>
          <Spacer size={[40, 160]} />
        </HubspotFormWrapper>
    </HubspotFormMain>
  )
}

HubspotForm.propTypes = {
  content: PropTypes.object
}

export default HubspotForm
